module.exports = __webpack_public_path__ + "static/assets/be0a443587973a4609c207240bac434f.png";